/*
 js loader: app
 file: unwetter.js
*/

/**
 * Created by sw on 27.01.2016.
 */
(function ($) {

	let _options = {};
	let _selector = false;

	$.uwdDemo = function (options, selector) {
		options = options || {};
		options.region = 'HIT';
		options.level = 1;
		options.disableDuration = 0;
		options.debug = false;

		selector = selector || _selector;

		if (!selector) {
			console.log('No selector given! Can\'t init. Correct usage: $.uwdDemo({}, \'body\')');
		} else {
			let settings = $.extend(_options, options);
			$(selector).uwd(settings);
		}

		return 'Demo started!';
	};

	$.fn.uwd = function (options) {

		let that = this;

		_options = options;
		_selector = that.selector;
		let cssLink = null;

		let settings = $.extend({
			//default options
			arrowPosition: 'center', //center, left, right, inner
			barPosition: 'top', //top, bottom, ('custom' -> force the arrowPosition to 'inner')
			template: 'default',
			region: 'HH',
			level: 2, //1 & 2 -> Wetterwarnung | 3 -> Warnung vor markantem Wetter | 4 -> Unwetterwarnung | 5 -> Warnung vor extremem Unwetter
			css: 'default', //default, light, dark, customName
			animation: 'down', //up, down, false
			domInsert: 'prepend', //prepend, append
			hideBarOnOpenScreen: true,
			debug: false,
			closable: true,
			disableDuration: 0,
			api: {
				rest: 'https://unwetter.ceasy.de/',
				css: 'https://unwetter.ceasy.de/assets/main/css/themes/'
			}
		}, options);

		let closed = false;

		let init = function () {
			log('Configuration loaded: ', settings);
			if (!getCookie('uwd_closed') || settings.disableDuration === 0) {
				loadTemplate();
			} else {
				log('weather not loaded, cookie found');
			}
		};

		let loadTemplate = function () {
			let url = settings.api.rest + 'weatherBar';
			let data = {region: settings.region, template: settings.template, level: settings.level};
			log('Loading template... ');
			log('TemplateUrl: ' + url + ' Parameter: ', data);

			let insertTemplate = function (template) {
				log('Template loaded');
				if (settings.domInsert === 'append') {
					that.append(template);
					log('Template appended');
				} else {
					that.prepend(template);
					log('Template prepended');
				}

				$('.uwd_weatherScreen').parent().prependTo('body');

				if (settings.barPosition !== 'custom') {
					let top = settings.barPosition === 'top';
					$('.uwd_weatherBar').addClass(top ? 'uwd_fixedTop' : 'uwd_fixedBottom');
					$('.uwd_openScreen').addClass(top ? 'uwd_bottom' : 'uwd_top').addClass('uwd_' + settings.arrowPosition);

				} else {
					$('.uwd_openScreen').addClass('uwd_inner');
				}

				if (settings.animation) {
					let down = settings.animation === 'down';
					$('.uwd_weatherBar').addClass(down ? 'uwd_fadeInDown' : 'uwd_fadeInUp');
					$('.uwd_warningBox').addClass(down ? 'uwd_fadeInDown' : 'uwd_fadeInUp');
				} else {
					$('.uwd_warningBox').addClass('uwd_fadeInDown');
				}

				if (settings.closable) {
					$('.uwd_closeBar').on('click', function () {
						log('closed');
						closed = true; //prevent other events
						if (settings.disableDuration !== 0) {
							setCookie('uwd_closed', true, settings.disableDuration);
						}
						$('.uwd_unwetter').remove();
						$(cssLink).remove();

					});
				} else {
					$('.uwd_closeBtnArea').hide();
				}

				let closeScreen = function () {
					if (!closed) {
						log('screen closed');
						$('.uwd_weatherScreen').hide();
						log('show bar');
						$('.uwd_weatherBar').show();
					}
				};

				$('.uwd_close').on('click', closeScreen);
				$('.uwd_outer').on('click', function (e) {
					if (e.target === this) {
						closeScreen();
					}
				});

				$(document).on('keydown', function (e) {
					log('Keydown ' + e.keyCode);
					if (e.keyCode == 27) {
						closeScreen();
					}
				});

				$('.uwd_weatherBar').on('click', function () {
					if (!closed) {
						log('open screen');
						$('.uwd_weatherScreen').show();
						if (settings.hideBarOnOpenScreen) {
							log('hiding bar');
							$('.uwd_weatherBar').hide();
						}
					}
				});

				$('.uwd_detailsArea').each(function () {
					let area = this;
					$(area).find('.uwd_detailsBtn').on('click', function () {
						$(area).toggleClass('uwd_open');
					})
				});
			};

			let onSuccess = function (template) {
				if (template.length > 0) {
					loadCss(function () {
						insertTemplate(template);
					});
				}
			};

			let request = $.ajax({
				url: url,
				data: data,
				crossDomain: true,
				dataType: 'html',
				statusCode: {
					204: function () {
						log('no warnings found for this reg');
					},
					200: onSuccess
				}
			}).fail(function (response, status, errorThrown) {
				log('Ajax Error: ' + response.responseText);
				log('Ajax Error: ' + status.responseText);
				log('Ajax Error: ' + errorThrown);
			});
		};

		let setCookie = function (name, value, expireMinutes) {
			let d = new Date();
			d.setTime(d.getTime() + (expireMinutes * 60 * 1000));
			let expires = "expires=" + d.toUTCString();
			document.cookie = name + "=" + value + "; " + expires;
			log('setting cookie: ' + document.cookie);
		};

		let getCookie = function (name) {
			name += "=";
			let ca = document.cookie.split(';');
			for (let i = 0; i < ca.length; i++) {
				let c = ca[i];
				while (c.charAt(0) === ' ') c = c.substring(1);
				if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
			}
			return "";
		};


		let loadCss = function (callback) {
			log('Loading css ...');

			let link = document.createElement('link');

			let loaded = false;

			link.onload = function () {
				if (!loaded) {
					log('css loaded');
					callback();
					loaded = true;
				}
			};

			$(link).attr('type', 'text/css');
			$(link).attr('rel', 'stylesheet');
			$(link).attr('href', settings.api.css + settings.css + '.css');

			cssLink = link;

			$('head').append(link);

			//force late call
			setTimeout(link.onload, 2000);
		};

		let log = function (msg, obj) {
			if (settings.debug) {
				msg = '[DEBUG] unWetter: ' + msg;
				if (obj) {
					console.log(msg, obj);
				} else {
					console.log(msg);
				}
			}
		};

		init();
	};
}(jQuery));